"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _index = require("../../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
// 图片结构组件
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = props.data,
      canDelete = props.canDelete,
      canReupload = props.canReupload,
      onDelete = props.onDelete,
      ImgContentComponent = props.ImgContentComponent,
      DisplayComponent = props.DisplayComponent,
      ItemAppendComponent = props.ItemAppendComponent,
      MaskContentComponent = props.MaskContentComponent,
      setUploader = props.setUploader,
      index = props.index,
      controls = props.controls,
      required = props.required,
      upload = props.upload,
      type = props.type,
      useFileAPI = props.useFileAPI,
      onMouseOut = props.onMouseOut,
      onMouseOver = props.onMouseOver,
      onClick = props.onClick; // 图片内容结构组件

  var component = _react["default"].createElement(ImgContentComponent, {
    useFileAPI: useFileAPI,
    type: type,
    upload: upload,
    canReupload: canReupload,
    className: (0, _classnames["default"])('img-li', {
      'img-li-video': type === 'video' || (0, _index.isVideo)(data.url)
    }),
    data: data,
    canDelete: canDelete,
    required: required,
    onDelete: onDelete,
    controls: controls,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    onClick: onClick,
    DisplayComponent: DisplayComponent,
    ItemAppendComponent: ItemAppendComponent,
    MaskContentComponent: MaskContentComponent
  });

  var result = null; // 可以上传才用setUploader设置一下

  if (canReupload && upload) {
    result = setUploader(component, {
      onComplete: function onComplete(err, xhr) {
        var resp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var fileTarget = arguments.length > 3 ? arguments[3] : undefined;
        var fileId = arguments.length > 4 ? arguments[4] : undefined;
        var propsOnComplete = props.onComplete;

        if ((0, _spauiUtils.isFunction)(propsOnComplete)) {
          propsOnComplete(resp, index, data, fileTarget, fileId, err, xhr);
        }
      }
    });
  } else {
    result = component;
  }

  return result;
};

exports["default"] = _default;